<!-- <app-app-headers (filnalFilters)="filnalFilters($event)"></app-app-headers> -->

<app-table-component (onPagination)="onPagination($event)"
                     [props]="tableConfigAndProps"
                     [isViewClick]="false"
                     height="23vh"
                     (selectedItem)="actionButtonOutput($event)"></app-table-component>
